module.exports = __webpack_public_path__ + "img/logo.ae423ff0.svg";